var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "device-list-filters" } }, [
    _c(
      "form",
      { staticClass: "mt-1" },
      [
        _c("output", { staticClass: "visually-hidden d-xl-none" }, [
          _vm._v(
            "\n            " + _vm._s(_vm.resultsAccessibleLabel) + "\n        "
          ),
        ]),
        _vm._v(" "),
        _vm.categoryCards.length > 0
          ? _c("accordion", {
              staticClass: "mt-2",
              attrs: {
                "element-type": "h3",
                cards: _vm.categoryParentCard,
                "accordion-id": "device-list-filters-categories-parent",
                "is-large": "",
              },
              on: { "on-toggle": _vm.trackTms },
              scopedSlots: _vm._u(
                [
                  _vm.hasNoSubCategories
                    ? {
                        key: "filter-category-parent-header",
                        fn: function () {
                          return [
                            _c("fieldset", [
                              _c("legend", {
                                attrs: {
                                  "aria-labelledby":
                                    "filter-category-parent-header",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "ul",
                                { staticClass: "list-unstyled ms-1" },
                                [
                                  _c(
                                    "li",
                                    [
                                      _vm.selectedCategory === null
                                        ? _c(
                                            "p",
                                            { staticClass: "fw-bold mb-0" },
                                            [
                                              _c("span", {
                                                staticClass:
                                                  "icon icon-checkbox-tick",
                                                attrs: {
                                                  "aria-hidden": "true",
                                                },
                                              }),
                                              _c("span", {
                                                staticClass: "ms-1",
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.allProductsLabel
                                                  ),
                                                },
                                              }),
                                            ]
                                          )
                                        : _c("Lien", {
                                            attrs: {
                                              label: _vm.allProductsLabel,
                                              "prevent-default": "",
                                              "is-button": "",
                                              "tms-category": _vm.tmsCategory(
                                                _vm.departmentLabel
                                              ),
                                              "tms-action":
                                                _vm.tmsAction("tous"),
                                              "tms-label": _vm.tmsLabel(
                                                _vm.allProductsLabel
                                              ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.selectCategory(null)
                                              },
                                            },
                                          }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm._l(_vm.categories, function (category) {
                                    return _c(
                                      "li",
                                      { key: category.seoId },
                                      [
                                        _vm.selectedCategory === category.seoId
                                          ? _c(
                                              "p",
                                              { staticClass: "fw-bold mb-0" },
                                              [
                                                _c("span", {
                                                  staticClass:
                                                    "icon icon-checkbox-tick",
                                                  attrs: {
                                                    "aria-hidden": "true",
                                                  },
                                                }),
                                                _c("span", {
                                                  staticClass: "ms-1",
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      category.label
                                                    ),
                                                  },
                                                }),
                                              ]
                                            )
                                          : _c("Lien", {
                                              attrs: {
                                                label: category.label,
                                                "prevent-default": "",
                                                "is-button": "",
                                                "tms-category": _vm.tmsCategory(
                                                  _vm.departmentLabel
                                                ),
                                                "tms-action": _vm.tmsAction(
                                                  category.label
                                                ),
                                                "tms-label": _vm.tmsLabel(
                                                  category.label
                                                ),
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.selectCategory(
                                                    category.seoId
                                                  )
                                                },
                                              },
                                            }),
                                      ],
                                      1
                                    )
                                  }),
                                ],
                                2
                              ),
                            ]),
                          ]
                        },
                        proxy: true,
                      }
                    : _vm.categoryCards.length > 0
                    ? {
                        key: "filter-category-parent-header",
                        fn: function () {
                          return [
                            _c(
                              "fieldset",
                              [
                                _c("legend", {
                                  attrs: {
                                    "aria-labelledby":
                                      "filter-category-parent-header",
                                  },
                                }),
                                _vm._v(" "),
                                _c("accordion", {
                                  attrs: {
                                    "element-type": "h4",
                                    cards: _vm.categoryCards,
                                    "one-at-time": "",
                                    "accordion-id":
                                      "device-list-filters-categories",
                                  },
                                  on: { "on-toggle": _vm.trackTms },
                                  scopedSlots: _vm._u(
                                    [
                                      _vm._l(
                                        _vm.categories,
                                        function (category) {
                                          return {
                                            key: `filter-category-header-${category.seoId}`,
                                            fn: function () {
                                              return [
                                                _c(
                                                  "fieldset",
                                                  { key: category.seoId },
                                                  [
                                                    _c("legend", {
                                                      attrs: {
                                                        "aria-labelledby":
                                                          "filter-category-header-" +
                                                          category.seoId,
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "ul",
                                                      {
                                                        staticClass:
                                                          "list-unstyled ms-1",
                                                      },
                                                      [
                                                        _c(
                                                          "li",
                                                          [
                                                            _vm.selectedCategory ===
                                                              category.seoId &&
                                                            _vm.selectedSubCategory ===
                                                              null
                                                              ? _c(
                                                                  "p",
                                                                  {
                                                                    staticClass:
                                                                      "fw-bold mb-0",
                                                                  },
                                                                  [
                                                                    _c("span", {
                                                                      staticClass:
                                                                        "icon icon-checkbox-tick",
                                                                      attrs: {
                                                                        "aria-hidden":
                                                                          "true",
                                                                      },
                                                                    }),
                                                                    _c("span", {
                                                                      staticClass:
                                                                        "ms-1",
                                                                      domProps:
                                                                        {
                                                                          innerHTML:
                                                                            _vm._s(
                                                                              _vm.allProductsLabel
                                                                            ),
                                                                        },
                                                                    }),
                                                                  ]
                                                                )
                                                              : _c("Lien", {
                                                                  attrs: {
                                                                    label:
                                                                      _vm.allProductsLabel,
                                                                    "prevent-default":
                                                                      "",
                                                                    "is-button":
                                                                      "",
                                                                    "tms-category":
                                                                      _vm.tmsCategory(
                                                                        _vm.departmentLabel
                                                                      ),
                                                                    "tms-action":
                                                                      _vm.tmsAction(
                                                                        category.label
                                                                      ),
                                                                    "tms-label":
                                                                      _vm.tmsLabel(
                                                                        _vm.allProductsLabel
                                                                      ),
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.selectCategory(
                                                                          category.seoId
                                                                        )
                                                                      },
                                                                  },
                                                                }),
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _vm._l(
                                                          category.subCategories,
                                                          function (
                                                            subCategory
                                                          ) {
                                                            return _c(
                                                              "li",
                                                              {
                                                                key: subCategory.seoId,
                                                              },
                                                              [
                                                                _vm.selectedSubCategory ===
                                                                subCategory.seoId
                                                                  ? _c(
                                                                      "p",
                                                                      {
                                                                        staticClass:
                                                                          "fw-bold mb-0",
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "icon icon-checkbox-tick",
                                                                            attrs:
                                                                              {
                                                                                "aria-hidden":
                                                                                  "true",
                                                                              },
                                                                          }
                                                                        ),
                                                                        _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "ms-1",
                                                                            domProps:
                                                                              {
                                                                                innerHTML:
                                                                                  _vm._s(
                                                                                    subCategory.label
                                                                                  ),
                                                                              },
                                                                          }
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _c("Lien", {
                                                                      attrs: {
                                                                        label:
                                                                          subCategory.label,
                                                                        "prevent-default":
                                                                          "",
                                                                        "is-button":
                                                                          "",
                                                                        "tms-category":
                                                                          _vm.tmsCategory(
                                                                            _vm.departmentLabel
                                                                          ),
                                                                        "tms-action":
                                                                          _vm.tmsAction(
                                                                            category.label
                                                                          ),
                                                                        "tms-label":
                                                                          _vm.tmsLabel(
                                                                            subCategory.label
                                                                          ),
                                                                      },
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            return _vm.selectCategory(
                                                                              category.seoId,
                                                                              subCategory.seoId
                                                                            )
                                                                          },
                                                                      },
                                                                    }),
                                                              ],
                                                              1
                                                            )
                                                          }
                                                        ),
                                                      ],
                                                      2
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          }
                                        }
                                      ),
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                        proxy: true,
                      }
                    : null,
                ],
                null,
                true
              ),
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.thirdPartyEnabled
          ? _c("fieldset", { staticClass: "mt-1" }, [
              _c("legend", {
                attrs: { "aria-labelledby": "firstPartyOnlyLabel" },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "d-flex" },
                [
                  _c(
                    "label",
                    {
                      staticClass: "standard",
                      attrs: {
                        id: "firstPartyOnlyLabel",
                        for: "firstPartyOnly",
                      },
                    },
                    [
                      _c("span", [
                        _vm._v("Vendu uniquement par "),
                        _c("strong", [_vm._v(_vm._s(_vm.shopBrandLabel))]),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("SwitchButton", {
                    staticClass: "ms-auto",
                    attrs: {
                      id: "firstPartyOnly",
                      checked: _vm.firstPartyOnlyChecked,
                    },
                    on: { change: _vm.toggleFirstPartyOnly },
                  }),
                ],
                1
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("accordion", {
          staticClass: "mt-1",
          attrs: {
            "element-type": "h3",
            cards: _vm.accordionCards,
            "accordion-id": "device-list-filters-accordion",
            "is-large": "",
          },
          on: { "on-toggle": _vm.trackTms },
          scopedSlots: _vm._u(
            [
              _vm._l(_vm.selectorGroupsCheckboxes, function (selectorGroup) {
                return {
                  key: `filter-selector-group-header-${selectorGroup.id}`,
                  fn: function () {
                    return [
                      _c("fieldset", { key: selectorGroup.seoId }, [
                        _c("legend", {
                          attrs: {
                            "aria-labelledby":
                              "'filter-selector-group-header-' + selectorGroup.id",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "ul",
                          {
                            staticClass: "list-unstyled",
                            attrs: { "aria-labelledby": "filter-brand-header" },
                          },
                          _vm._l(selectorGroup.selectors, function (selector) {
                            return _c(
                              "li",
                              { key: selector.id },
                              [
                                _c("CheckBox", {
                                  attrs: {
                                    id: selector.id,
                                    label: selector.label,
                                    "aria-label": selector.label,
                                    "model-value": selector.isChecked,
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.toggleSelector(
                                        selector.id,
                                        $event
                                      )
                                    },
                                  },
                                }),
                              ],
                              1
                            )
                          }),
                          0
                        ),
                      ]),
                    ]
                  },
                  proxy: true,
                }
              }),
              _vm.statusCheckboxes.length > 0
                ? {
                    key: "filter-status-header",
                    fn: function () {
                      return [
                        _c("fieldset", [
                          _c("legend", {
                            attrs: {
                              "aria-labelledby": "filter-status-header",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "ul",
                            {
                              staticClass: "list-unstyled",
                              attrs: {
                                "aria-labelledby": "filter-status-header",
                              },
                            },
                            _vm._l(_vm.statusCheckboxes, function (checkbox) {
                              return _c(
                                "li",
                                { key: checkbox.name },
                                [
                                  _c("CheckBox", {
                                    attrs: {
                                      id: checkbox.id,
                                      label: checkbox.label,
                                      "aria-label": checkbox.accessibleLabel,
                                      "model-value": checkbox.isChecked,
                                      "is-disabled": checkbox.disabled,
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.toggleStatus(
                                          checkbox.id,
                                          $event
                                        )
                                      },
                                    },
                                  }),
                                ],
                                1
                              )
                            }),
                            0
                          ),
                        ]),
                      ]
                    },
                    proxy: true,
                  }
                : null,
              _vm.brandCheckboxes.length > 0
                ? {
                    key: "filter-brand-header",
                    fn: function () {
                      return [
                        _c(
                          "fieldset",
                          [
                            _c("legend", {
                              attrs: {
                                "aria-labelledby": "filter-brand-header",
                              },
                            }),
                            _vm._v(" "),
                            _c("ob1-search-field", {
                              attrs: {
                                id: "brand-search-field",
                                "input-value": _vm.brandSearchValue,
                                label: _vm.brandSearchLabel,
                                "with-auto-completion": false,
                                "show-auto-completion": false,
                                "is-mini": "",
                              },
                              on: { input: _vm.filterBrands },
                            }),
                            _vm._v(" "),
                            _c("output", { staticClass: "visually-hidden" }, [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.availableBrandFoundLabel) +
                                  "\n                    "
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "ul",
                              {
                                staticClass: "list-unstyled",
                                attrs: {
                                  "aria-labelledby": "filter-brand-header",
                                },
                              },
                              [
                                _vm._l(
                                  _vm.notCollapsableBrandCheckboxes,
                                  function (checkbox) {
                                    return _c(
                                      "li",
                                      { key: checkbox.name },
                                      [
                                        _c("CheckBox", {
                                          attrs: {
                                            id: checkbox.id,
                                            label: checkbox.label,
                                            "aria-label":
                                              checkbox.accessibleLabel,
                                            "model-value": checkbox.isChecked,
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.toggleBrand(
                                                checkbox.id,
                                                $event
                                              )
                                            },
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  }
                                ),
                                _vm._v(" "),
                                _vm.collapsableBrandCheckboxes.length > 0
                                  ? _c(
                                      "LinkFoldUnFold",
                                      {
                                        attrs: {
                                          "button-id": "collapsed-brand-header",
                                          "button-label":
                                            _vm.collapsableBrandButtonLabel,
                                          "with-link-bottom": true,
                                          "collapsed-block-id":
                                            "brand-collapsed-block",
                                        },
                                        on: {
                                          "ob1-liens-haut-bas-show-block":
                                            _vm.brandShow,
                                          "ob1-liens-haut-bas-hide-block":
                                            _vm.brandHide,
                                        },
                                      },
                                      _vm._l(
                                        _vm.collapsableBrandCheckboxes,
                                        function (checkbox) {
                                          return _c(
                                            "li",
                                            { key: checkbox.name },
                                            [
                                              _c("CheckBox", {
                                                attrs: {
                                                  id: checkbox.id,
                                                  label: checkbox.label,
                                                  "aria-label":
                                                    checkbox.accessibleLabel,
                                                  "model-value":
                                                    checkbox.isChecked,
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    return _vm.toggleBrand(
                                                      checkbox.id,
                                                      $event
                                                    )
                                                  },
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                      0
                                    )
                                  : _vm._e(),
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  }
                : null,
              _vm.bonusRangesCheckboxes.length > 0
                ? {
                    key: "filter-bonus-header",
                    fn: function () {
                      return [
                        _c("fieldset", [
                          _c("legend", {
                            attrs: { "aria-labelledby": "filter-bonus-header" },
                          }),
                          _vm._v(" "),
                          _c(
                            "ul",
                            {
                              staticClass: "list-unstyled",
                              attrs: {
                                "aria-labelledby": "filter-bonus-header",
                              },
                            },
                            _vm._l(
                              _vm.bonusRangesCheckboxes,
                              function (checkbox) {
                                return _c(
                                  "li",
                                  { key: checkbox.name },
                                  [
                                    _c("CheckBox", {
                                      attrs: {
                                        id: checkbox.id,
                                        label: checkbox.label,
                                        "aria-label": checkbox.accessibleLabel,
                                        "model-value": checkbox.isChecked,
                                        "is-disabled": checkbox.disabled,
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.toggleBonusRanges(
                                            checkbox.id,
                                            $event
                                          )
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                )
                              }
                            ),
                            0
                          ),
                        ]),
                      ]
                    },
                    proxy: true,
                  }
                : null,
              _vm.priceCheckboxes.length > 0
                ? {
                    key: "filter-price-header",
                    fn: function () {
                      return [
                        _c("fieldset", [
                          _c("legend", {
                            attrs: { "aria-labelledby": "filter-price-header" },
                          }),
                          _vm._v(" "),
                          _c(
                            "ul",
                            {
                              staticClass: "list-unstyled",
                              attrs: {
                                "aria-labelledby": "filter-price-header",
                              },
                            },
                            _vm._l(_vm.priceCheckboxes, function (checkbox) {
                              return _c(
                                "li",
                                { key: checkbox.name },
                                [
                                  _c("CheckBox", {
                                    attrs: {
                                      id: checkbox.id,
                                      label: checkbox.label,
                                      "aria-label": checkbox.accessibleLabel,
                                      "model-value": checkbox.isChecked,
                                      "is-disabled": checkbox.disabled,
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.togglePrice(
                                          checkbox.id,
                                          $event
                                        )
                                      },
                                    },
                                  }),
                                ],
                                1
                              )
                            }),
                            0
                          ),
                        ]),
                      ]
                    },
                    proxy: true,
                  }
                : null,
              _vm.compatibilityCheckboxes.length > 0
                ? {
                    key: "filter-compatibility-header",
                    fn: function () {
                      return [
                        _c("fieldset", [
                          _c("legend", {
                            attrs: {
                              "aria-labelledby": "filter-compatibility-header",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "ul",
                            {
                              staticClass: "list-unstyled",
                              attrs: {
                                "aria-labelledby":
                                  "filter-compatibility-header",
                              },
                            },
                            _vm._l(
                              _vm.compatibilityCheckboxes,
                              function (checkbox) {
                                return _c(
                                  "li",
                                  { key: checkbox.value },
                                  [
                                    _c("CheckBox", {
                                      attrs: {
                                        id: checkbox.id,
                                        label: checkbox.label,
                                        "aria-label": checkbox.accessibleLabel,
                                        "model-value": checkbox.isChecked,
                                        "is-disabled": checkbox.disabled,
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.toggleCompatibility(
                                            checkbox.id,
                                            $event
                                          )
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                )
                              }
                            ),
                            0
                          ),
                        ]),
                      ]
                    },
                    proxy: true,
                  }
                : null,
              _vm.noteCheckboxes.length > 0
                ? {
                    key: "filter-note-header",
                    fn: function () {
                      return [
                        _c("fieldset", [
                          _c("legend", {
                            attrs: { "aria-labelledby": "filter-note-header" },
                          }),
                          _vm._v(" "),
                          _c(
                            "ul",
                            {
                              staticClass: "list-unstyled",
                              attrs: {
                                "aria-labelledby": "filter-note-header",
                              },
                            },
                            _vm._l(_vm.noteCheckboxes, function (checkbox) {
                              return _c(
                                "li",
                                {
                                  key: checkbox.name,
                                  staticClass: "d-flex mb-1",
                                },
                                [
                                  _c("CheckBox", {
                                    staticClass: "mb-0",
                                    attrs: {
                                      id: checkbox.id,
                                      "aria-label": checkbox.accessibleLabel,
                                      "model-value": checkbox.isChecked,
                                      "is-disabled": checkbox.disabled,
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.toggleNote(
                                          checkbox.id,
                                          $event
                                        )
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "d-flex",
                                      attrs: { "aria-hidden": "true" },
                                    },
                                    [
                                      _c("Rating", {
                                        staticClass: "filter-rating-item",
                                        attrs: {
                                          average: Number(checkbox.value),
                                          "rating-results-height": 1.01,
                                          "font-size": 0.875,
                                          text: _vm.ratingText(checkbox),
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            }),
                            0
                          ),
                        ]),
                      ]
                    },
                    proxy: true,
                  }
                : null,
              _vm.efficiencyClassesCheckboxes.length > 0
                ? {
                    key: "filter-efficiency-classes-header",
                    fn: function () {
                      return [
                        _c("fieldset", [
                          _c("legend", {
                            attrs: {
                              "aria-labelledby":
                                "filter-efficiency-classes-header",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "ul",
                            {
                              staticClass: "list-unstyled",
                              attrs: {
                                "aria-labelledby":
                                  "filter-efficiency-classes-header",
                              },
                            },
                            [
                              _vm._l(
                                _vm.notCollapsableEfficiencyClassesCheckboxes,
                                function (checkbox) {
                                  return _c(
                                    "li",
                                    {
                                      key: checkbox.value,
                                      staticClass: "d-flex",
                                    },
                                    [
                                      _c("CheckBox", {
                                        attrs: {
                                          id: checkbox.id,
                                          "aria-label":
                                            checkbox.accessibleLabel,
                                          "model-value": checkbox.isChecked,
                                          "is-disabled": checkbox.disabled,
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.toggleEfficiencyClass(
                                              checkbox.id,
                                              $event
                                            )
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "d-flex",
                                          attrs: { "aria-hidden": "true" },
                                        },
                                        [
                                          _c("img", {
                                            attrs: {
                                              alt:
                                                "terminal de classe énergétique " +
                                                checkbox.label,
                                              height: "19",
                                              src: checkbox.efficiencyClassImage,
                                            },
                                          }),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                }
                              ),
                              _vm._v(" "),
                              _vm.collapsableEfficiencyClassesCheckboxes
                                .length > 0
                                ? _c(
                                    "LinkFoldUnFold",
                                    {
                                      attrs: {
                                        "button-id":
                                          "collapsed-efficiency-classes-header",
                                        "button-label":
                                          _vm.collapsableEfficiencyClassesButtonLabel,
                                        "with-link-bottom": true,
                                        "collapsed-block-id":
                                          "efficiency-classes-collapsed-block",
                                      },
                                      on: {
                                        "ob1-liens-haut-bas-show-block":
                                          _vm.efficiencyClassesShow,
                                        "ob1-liens-haut-bas-hide-block":
                                          _vm.efficiencyClassesHide,
                                      },
                                    },
                                    _vm._l(
                                      _vm.collapsableEfficiencyClassesCheckboxes,
                                      function (checkbox) {
                                        return _c(
                                          "li",
                                          {
                                            key: checkbox.name,
                                            staticClass: "d-flex",
                                          },
                                          [
                                            _c("CheckBox", {
                                              attrs: {
                                                id: checkbox.id,
                                                "aria-label":
                                                  checkbox.accessibleLabel,
                                                "model-value":
                                                  checkbox.isChecked,
                                                "is-disabled":
                                                  checkbox.disabled,
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.toggleEfficiencyClass(
                                                    checkbox.id,
                                                    $event
                                                  )
                                                },
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "d-flex",
                                                attrs: {
                                                  "aria-hidden": "true",
                                                },
                                              },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    alt:
                                                      "terminal de classe énergétique " +
                                                      checkbox.label,
                                                    height: "19",
                                                    src: checkbox.efficiencyClassImage,
                                                  },
                                                }),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    0
                                  )
                                : _vm._e(),
                            ],
                            2
                          ),
                        ]),
                      ]
                    },
                    proxy: true,
                  }
                : null,
            ],
            null,
            true
          ),
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }